import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { BetSlipProvider } from "@/context/BetSlipContext";
import { DisplayProvider } from "@/context/DisplayContext";
import { NotificationsProvider } from "@/context/NotificationsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Layout from "@/components/Layout";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import Home from "@/pages/Home";
import AdminAccounts from "@/pages/AdminAccounts";
import AdminModelTuning from "@/pages/AdminModelTuning";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import Mates from "@/pages/Mates";
import Tournaments from "@/pages/Tournaments";
import TournamentDetail from "@/pages/TournamentDetail";
import BestBets from "@/pages/BestBets";
import ValueBets from "@/pages/ValueBets";
import TrackRecord from "@/pages/TrackRecord";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <BetSlipProvider>
              <DisplayProvider>
              <NotificationsProvider>
              <Routes>
                <Route path="/auth" element={<Auth />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route
                  element={
                    <ProtectedRoute>
                      <Layout />
                    </ProtectedRoute>
                  }
                >
                  <Route path="/" element={<Home />} />
                  <Route path="/bets" element={<Navigate to="/" replace />} />
                  <Route path="/tournaments" element={<Tournaments />} />
                  <Route path="/tournaments/:name" element={<TournamentDetail />} />
                  <Route path="/best-bets" element={<BestBets />} />
                  <Route path="/value-finder" element={<ValueBets />} />
                  <Route
                    path="/track-record"
                    element={
                      <AdminRoute>
                        <TrackRecord />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/accounts"
                    element={
                      <AdminRoute>
                        <AdminAccounts />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/model-tuning"
                    element={
                      <AdminRoute>
                        <AdminModelTuning />
                      </AdminRoute>
                    }
                  />
                  <Route path="/groups" element={<Groups />} />
                  <Route path="/groups/:id" element={<GroupDetail />} />
                  <Route path="/mates" element={<Mates />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              </NotificationsProvider>
              </DisplayProvider>
            </BetSlipProvider>
          </BrowserRouter>
          <Toaster position="bottom-center" richColors />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
